import i18n from '@/i18n';

const INTL_LOCALES: Record<string, string> = { uz: 'uz-UZ', ru: 'ru-RU', en: 'en-US' };

/** BCP-47 locale for Intl / toLocale*String based on the current UI language. */
export const intlLocale = (): string => INTL_LOCALES[i18n.language] ?? 'uz-UZ';
